export class Credentials {
    constructor(
        public hkMode: boolean,
    ){}
}